import { PageLayout } from '@/components/templates/PageLayout';
import {
  CmCard,
  CmFlex,
  CmLabelAndSelect,
  CmMessageCard,
  CmNextLink,
  CmScrollBox,
  CmSeparate,
  CmText,
} from '@/components/uiParts';
import { routes } from '@/router';

import { CouponTable } from './components';
import { Coupon, Site } from './types';

type Props = {
  coupons: Coupon[];
  sites: Site[];
  changeUrlHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  targetSite: Site;
  handleStatusChange: (id: string, value: string) => void;
};

export const CamelOrderCouponsTemplate: React.FC<Props> = ({
  coupons,
  sites,
  changeUrlHandler,
  targetSite,
  handleStatusChange,
}) => {
  return (
    <PageLayout title={routes.camelOrderCoupons.title}>
      {sites.length === 0 ? (
        <CmMessageCard margin="100px auto 0">
          サイト情報が登録されていません。
        </CmMessageCard>
      ) : (
        <CmCard
          mt="25px"
          height={`calc(100vh - 120px)`}
          padding={'20px 40px 10px'}
        >
          <CmFlex justify="space-between">
            <CmFlex alignItems="center" p="0 0 10px">
              <CmLabelAndSelect
                id={'siteUrl'}
                label={'サイトURLを選択'}
                width="300px"
                fontWeight="bold"
                value={targetSite.id}
                onChange={changeUrlHandler}
              >
                {sites.map((site) => (
                  <option key={site.url} value={site.id}>
                    {site.url}
                  </option>
                ))}
              </CmLabelAndSelect>
            </CmFlex>
            <CmFlex alignItems="center" pb="5px">
              <CmText minWidth="75px">件数{coupons.length}件</CmText>
              <CmSeparate mx="30px" />
              <CmNextLink to={`/camel-order/coupons/${targetSite.id}/new`}>
                新規追加
              </CmNextLink>
            </CmFlex>
          </CmFlex>
          <CmScrollBox>
            <CouponTable
              coupons={coupons}
              handleStatusChange={handleStatusChange}
            />
          </CmScrollBox>
        </CmCard>
      )}
    </PageLayout>
  );
};
